import * as A from "fp-ts-esm/Array";
import { pipe } from "fp-ts-esm/function";
import { Node_Type, TableCellData_VerticalAlignment } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { addNode } from "./builder-utils.js";
import {
  createNode,
  createTextNode,
  DEFAULT_CONTAINER_DATA,
  DEFAULT_PARAGRAPH_DATA
} from "./node-builder-methods.js";
const DEFAULT_CELL_DATA = {
  cellStyle: {
    verticalAlignment: TableCellData_VerticalAlignment.TOP
  },
  borderColors: {}
};
const DEFAULT_LAYOUT_DIMS = {
  colsMinWidth: 120,
  rowsHeight: 47,
  colsWidthRatio: 10
};
const toCellNode = (generateId) => (cell) => createNode(generateId)(
  Node_Type.TABLE_CELL,
  cell.data || DEFAULT_CELL_DATA,
  cell.content.nodes
);
const toRowNode = (generateId) => (row) => createNode(generateId)(
  Node_Type.TABLE_ROW,
  {},
  row.map(toCellNode(generateId))
);
const getMaxRowLength = (rows) => Math.max(...rows.map((r) => r.length));
const getEmptyCell = (generateId) => ({
  content: {
    nodes: [
      createTextNode(generateId)(
        Node_Type.PARAGRAPH,
        [{ text: "", decorations: [] }],
        DEFAULT_PARAGRAPH_DATA
      )
    ]
  }
});
const padRows = (rows, emptyCell) => (maxLen) => rows.map((r) => r.concat(Array(maxLen - r.length).fill(emptyCell)));
const calcTableDims = (rows) => [
  rows.length,
  rows.length > 0 ? rows[0].nodes.length : 0
];
const toDefaultTableData = (dims) => ({
  containerData: DEFAULT_CONTAINER_DATA,
  dimensions: {
    colsMinWidth: Array(dims[1]).fill(DEFAULT_LAYOUT_DIMS.colsMinWidth),
    colsWidthRatio: Array(dims[1]).fill(DEFAULT_LAYOUT_DIMS.colsWidthRatio),
    rowsHeight: Array(dims[0]).fill(DEFAULT_LAYOUT_DIMS.rowsHeight)
  }
});
const toTableData = (data) => (rows) => [rows, data || toDefaultTableData(calcTableDims(rows))];
const toTableNode = (generateId) => ([rows, data]) => createNode(generateId)(Node_Type.TABLE, data, rows);
const toContentWithTable = (args) => (node) => addNode({ ...args, node });
const toPaddedRowNodes = (generateId) => (cells) => pipe(
  cells,
  getMaxRowLength,
  padRows(cells, getEmptyCell(generateId)),
  A.map(toRowNode(generateId))
);
const makeTable = (generateId) => ({
  cells,
  data
}) => pipe(cells, toPaddedRowNodes(generateId), toTableData(data), toTableNode(generateId));
const addTable = (generateId) => ({
  cells,
  data,
  index,
  before,
  after,
  content
}) => pipe(
  makeTable(generateId)({ cells, data }),
  toContentWithTable({ index, before, after, content })
);
export {
  addTable,
  makeTable
};
//# sourceMappingURL=table-builder-api.js.map
